import Dto from "../service/Dto";
import StringConstrain from "../../../appl/model/validate/constrains/StringConstrain";
import IntegerConstrain from "../../../appl/model/validate/constrains/IntegerConstrain";
import FloatConstrain from "../../../appl/model/validate/constrains/FloatConstrain";
import BoolConstrain from "../../../appl/model/validate/constrains/BoolConstrain";
import DateTimeConstrain from "../../../appl/model/validate/constrains/DateTimeConstrain";
import NotBlankConstrain from "../../../appl/model/validate/constrains/NotBlankConstrain";
import NotBlankEnumConstrain from "../../../appl/model/validate/constrains/NotBlankEnumConstrain";
import Transformer from "../../../appl/model/validate/Transformer";

class DataType extends Dto {

  static BOOLEAN = 'DT_BOOLEAN';
  static INTEGER = 'DT_INTEGER';
  static FLOAT = 'DT_FLOAT';
  static STRING = 'DT_STRING';
  static DATETIME = 'DT_DATETIME';
  static ENUM = 'DT_ENUM';
  static DATA_EXT = 'DT_DATA_EXT';
  static OBJECT = 'DT_OBJECT';
  static MANY_TO_ONE = 'DT_MANY_TO_ONE';

  static ACCESS_MOD_PRIVATE = 'private';
  static ACCESS_MOD_PUBLIC = 'public';

  constructor(accountId = '') {
    super('po2\\types\\DataType');
  }

  /**
   * Gibt die passenden Constrain-Instanzen für einen fieldType zurück.
   * Spiegelt die serverseitige Logik aus DataType.php::__construct() und DataType.php::validate().
   *
   * @param {object} fieldType  Das fieldType-Objekt aus fieldsDef (hat .type, .nillable, .dataLength, ...)
   * @returns {ConstrainBase[]}
   */
  static getConstrains(fieldType) {
    const constrains = [];

    if (!fieldType.nillable) {
      if (fieldType.type === DataType.ENUM) {
        constrains.push(new NotBlankEnumConstrain());
      } else if (fieldType.type !== DataType.BOOLEAN && fieldType.type !== DataType.DATA_EXT && fieldType.type !== DataType.OBJECT) {
        constrains.push(new NotBlankConstrain());
      }
    }

    switch (fieldType.type) {
      case DataType.STRING:
        constrains.push(new StringConstrain(0, fieldType.dataLength > 0 ? fieldType.dataLength : -1));
        break;
      case DataType.INTEGER:
        constrains.push(new IntegerConstrain());
        break;
      case DataType.FLOAT:
        constrains.push(new FloatConstrain());
        break;
      case DataType.BOOLEAN:
        constrains.push(new BoolConstrain());
        break;
      case DataType.DATETIME:
        constrains.push(new DateTimeConstrain());
        break;
      case DataType.ENUM:
        // NotBlankEnumConstrain bereits oben eingefügt wenn nicht nillable
        break;
      case DataType.DATA_EXT:
      case DataType.OBJECT:
      case DataType.MANY_TO_ONE:
        // Keine automatischen Constrains
        break;
      default:
        break;
    }

    if (fieldType.type && fieldType.contrains) {
      if (Array.isArray(fieldType.contrains)) {
        for (let contrain of fieldType.contrains) {
          constrains.push(contrain);
        }
      } else {
        constrains.push(fieldType.contrains);
      }
    }

    // Zusätzliche Constrains aus dem Server-JSON (fieldType.constrains) auswerten.
    // Der Server liefert hier kein Array, sondern ein Objekt, das pro PHP-Klassenname
    // (Key) die serialisierten Eigenschaften des Constrains enthält (siehe Transformer.js).
    if (fieldType.constrains) {
      for (const serverConstrain of Transformer.transformConstrains(fieldType.constrains)) {
        constrains.push(serverConstrain);
      }
    }

    return constrains;
  }

  /** @deprecated Verwende getConstrains(fieldType) */
  static initConstrains(constrain) {
    // nicht mehr verwendet
  }
}
export default DataType